import * as XLSX from "xlsx";

/**
 * AUT-429 FR-8. `xlsx` is already a dependency and is already used for *reading* keyword uploads
 * (`utils/keywordInput.ts`); this is the write direction. Kept out of the page so the page stays
 * about rendering.
 */
export interface KeywordTrendExportRow {
  keyword: string;
  total: number;
  avg: number;
  weeks: number;
}

export function exportKeywordTrends(rows: KeywordTrendExportRow[], term: string): void {
  const sheet = XLSX.utils.json_to_sheet(
    rows.map((r) => ({
      Keyword: r.keyword,
      "Total volume": Math.round(r.total),
      "Avg weekly": Math.round(r.avg),
      "Weeks observed": r.weeks,
    })),
  );
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, "Keyword trends");
  XLSX.writeFile(book, `keyword-trends-${term.trim().replace(/\s+/g, "-") || "export"}.xlsx`);
}
